import React from 'react'

export const View = ({ children, ...props }) => (
  <div {...props}>{children}</div>
)

export const Text = ({ children, ...props }) => (
  <span {...props}>{children}</span>
)

export const TouchableWithoutFeedback = ({ children, onPress, ...props }) => (
  <button style={{ background: 'transparent',border: 'none'}} onClick={onPress} {...props}>{children}</button>
)

export const ActivityIndicator = (props) => (
  <span {...props}>Loading</span>
)

export const Image = ({ source }) => (
  <img src={source.uri} alt="dlasjdal" />
)

export const TextInput = ({ type='text', onChangeText, ...props}) => (
  <input onChange={({ target })=> onChangeText(target.value)} {...props} type={type} />
)

export const StyleSheet = {
  create: (groups) => {
    return Object.entries(groups).reduce((groups, [name, {flex, ...styles}]) => {
      if(flex === 1){
        styles.display = 'flex'
        if(!styles.flexDirection) styles.flexDirection = 'column'
      }
      return {...groups, [name]: styles }
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/react-native.js